module.exports = __webpack_public_path__ + "img/face-weary.6c26ce7d.svg";